import '@angular/compiler';
import { PagePolicyRecommendationComponent } from './page.policy.recommendation/page.policy.recommendation.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageRegionalAnalysisComponent } from './page.regional.analysis/page.regional.analysis.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageDataSourcesComponent } from './page.data.sources/page.data.sources.component';
import { ComponentRepresentativeRegionsComponent } from './component.representative.regions/component.representative.regions.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageSpecializationDistributionComponent } from './page.specialization.distribution/page.specialization.distribution.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PagePolicySimulatorComponent } from './page.policy.simulator/page.policy.simulator.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { ComponentPolicySimulatorComponent } from './component.policy.simulator/component.policy.simulator.component';
import { ComponentDashboardSummaryComponent } from './component.dashboard.summary/component.dashboard.summary.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { ComponentAnalysisNavigationComponent } from './component.analysis.navigation/component.analysis.navigation.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { ComponentRegionSelectorComponent } from './component.region.selector/component.region.selector.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';

const INDEX_PAGE = "specialization-distribution";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "policy-recommendation",
                component: PagePolicyRecommendationComponent,
                "app_id": "page.policy.recommendation"
            },
            {
                "path": "regional-analysis",
                component: PageRegionalAnalysisComponent,
                "app_id": "page.regional.analysis"
            },
            {
                "path": "data-sources",
                component: PageDataSourcesComponent,
                "app_id": "page.data.sources"
            },
            {
                "path": "specialization-distribution",
                component: PageSpecializationDistributionComponent,
                "app_id": "page.specialization.distribution"
            },
            {
                "path": "policy-simulator",
                component: PagePolicySimulatorComponent,
                "app_id": "page.policy.simulator"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    },
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    path: 'access',
    redirectTo: INDEX_PAGE,
    pathMatch: 'full'
}, {
    // 대안 1의 정보 흐름에 맞춰 루트 진입은 전국 분포에서 시작한다.
    path: '',
    redirectTo: INDEX_PAGE,
    pathMatch: 'full'
}, {
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
